import { useMemo, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";
import Collapse from "react-bootstrap/esm/Collapse";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

export function KPPlanetSchedule ({menuArray,userData,clientData, setErrorAlert}) {
  const [scheduleData, setScheduleData] = useState([]);
  const [showAndaram, setShowAndaram] = useState(false);
  const [planet, setPlanet] = useState(0);
  const [planetData, setPlanetData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Planet Schedule');
  const loop = [1,2,3];

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/planetschedule/"+clientId,
      (response)=>{
        setScheduleData(response.data);
        getPlanetData(clientId,planet);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setScheduleData([]);
        setSpinner(null);
        setErrorAlert(error.message);
      }
    );

    function getPlanetData(clientId,planet) {
      axiosGetWithHeader("/chart/allplanetschedule/"+clientId+"/"+planet,
        (response)=>{
          setPlanetData(response.data);
        },
        (error)=>{
          console.log(error);
          setPlanetData(null);
          setErrorAlert(error.message);
        }
      );
    }
  
  }, [userData,planet,setErrorAlert]);


  function handleAndaramVisible() {
    setShowAndaram(!showAndaram);
  }

  return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        { userData===null || userData===undefined?<></>:
          <Collapse in={menuArray[9]} className="m-0 p-0">
            <Row id="planetScheduleChart" className="m-0 p-0">
                  <Col xs={12} className="p-0 m-0">
        {  
          scheduleData===null||scheduleData.length===0?(
            <></>
          ):(
            <>
          <table class="table table-hover align-middle caption-top m-0 p-0 text-center TableFont">
            <caption class="m-0 p-2">
              <div class="m-0 p-0 row">
              <div class="m-0 p-0 col"><h5 class="m-0 p-2">Dasha Bhukti Andharam</h5></div>
              <div class="m-0 p-0 pe-2 col-7 text-end noprint"><button type="button" class="btn btn-outline-primary" onClick={handleAndaramVisible}>{showAndaram?"Summary":"Drilldown view"}</button></div>
              </div>
            </caption>
          </table>
          {showAndaram===false?
          <>
          <div class="row m-0 p-0 TableFont">
              <div class="col-12 col-md-6 col-lg-6 m-0 p-1 ps-3 text-start">
                Birth Time Dasha Balance : {clientData.dashaBalance} ({clientData.dashaName}) 
              </div>
              <div class="col-12 col-md-6 col-lg-6 m-0 p-1 pe-3 text-end">
                Current Dasha Balance : {clientData.currentDashaBalance} ({clientData.currentDashaName}) 
              </div>
          </div>    
          {loop.map((row, rowindex) => (
          <div class={rowindex===2?"m-0 p-0 row TableFont":rowindex===1?"m-0 p-0 row TableFont ":"m-0 p-0 row TableFont"}>
          {loop.map((col, colindex) => (
            <div class={rowindex===1 && colindex===1?"m-0 col-xs-12 col-md-4 pagebreakportrait":"m-0 col-xs-12 col-md-4"}>
              <table class="table table-borderless table-hover align-middle caption-top p-0 text-center TableFont">
                <thead>
                  <tr class="p-0"  data-bs-toggle="tooltip" data-bs-html="true" title={scheduleData[0][3].split(',')[(rowindex*3+colindex)]}>
                    <th class="text-start p-1 bg-info-subtle">{scheduleData[0][0].split(',')[(rowindex*3+colindex)]+" Dasha"}</th> 
                    <th class="text-center p-0 bg-info-subtle">{scheduleData[0][1].split(',')[(rowindex*3+colindex)]}</th> 
                    <th class="text-center p-0 bg-info-subtle">{scheduleData[0][2].split(',')[(rowindex*3+colindex)]}</th> 
                  </tr>
                </thead>  
                  <tbody>
                  {
                    scheduleData[(rowindex*3+col)][0].split(',').map((str,index)=>(
                      <tr name="trname" onClick={handleClickColor} class="p-0" data-bs-toggle="tooltip" title={scheduleData[(rowindex*3+col)][3].split(',')[index]} >
                        <th class="text-start p-1  bg-transparent" >{str}</th>
                        <td class="text-center p-0  bg-transparent">{scheduleData[(rowindex*3+col)][1].split(',')[index]}</td>
                        <td class="text-center p-0 bg-transparent">{scheduleData[(rowindex*3+col)][2].split(',')[index]}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
            ))}
          </div>    
            ))}
          </>  
            :
            <>
        {  
          planetData===null||planetData.length===0?(
            <></>
          ):(
            <>
            <div class="row m-0 p-0 pb-3">
              <div class="col-12 col-md-12 col-lg-12 m-0 p-0 text-center">
              <DropdownButton id="dropdown-basic-button" 
              title={"Dasha - [ "+ planetData[0][1].split(',')[planet]+" - "+ planetData[0][2].split(',')[planet]+" ] "+planetData[0][0].split(',')[planet]+" ( "+ planetData[0][3].split(',')[planet]+" )"}
              variant="success" class="m-0 p-0" size="md">
                { planetData[0][0].split(',').map((planetName,index)=>(
                  <Dropdown.Item onClick={()=>setPlanet(index)} >{"[ "+ planetData[0][1].split(',')[index]+" - "+ planetData[0][2].split(',')[index]+" ] "+planetName+" ( "+ planetData[0][3].split(',')[index]+" )"}</Dropdown.Item>
                ))}
              </DropdownButton>
              </div>  
            </div>
            <div class="row m-0 p-0 TableFont">
              <div class="col-12 col-md-6 col-lg-6 m-0 p-1 ps-3 text-start">
                Birth Time Dasha Balance : {clientData.dashaBalance} ({clientData.dashaName}) 
              </div>
              <div class="col-12 col-md-6 col-lg-6 m-0 p-1 pe-3 text-end">
                Current Dasha Balance : {clientData.currentAndharamBalance} ({clientData.currentDashaName}) 
              </div>
            </div>    

            {loop.map((row, rowindex) => (
              <div class={rowindex===2?"m-0 p-0 row TableFont":rowindex===1?"m-0 p-0 row TableFont ":"m-0 p-0 row TableFont"}>
              {loop.map((col, colindex) => (
                <div class={rowindex===1 && colindex===1?"m-0 col-xs-12 col-md-4 pagebreakportrait":"m-0 col-xs-12 col-md-4"}>
                  <table class="table table-borderless table-hover align-middle caption-top p-0 text-center TableFont">
                    <thead>
                      <tr class="p-0"  data-bs-toggle="tooltip" data-bs-html="true" title={planetData[1][3].split(',')[(rowindex*3+colindex)]}>
                        <th class="text-start  p-1 bg-success-subtle">{planetData[1][0].split(',')[(rowindex*3+colindex)]+" Bhukti"}</th> 
                        <th class="text-center p-1 bg-success-subtle">{planetData[1][1].split(',')[(rowindex*3+colindex)]}</th> 
                        <th class="text-center p-1 bg-success-subtle">{planetData[1][2].split(',')[(rowindex*3+colindex)]}</th> 
                      </tr>
                    </thead>  
                    <tbody>
                      {
                        planetData[(rowindex*3+col+1)][0].split(',').map((str,index)=>(
                          <tr name="trname" onClick={handleClickColor} class="p-0" data-bs-toggle="tooltip" title={planetData[(rowindex*3+col+1)][3].split(',')[index]} >
                            <th class="text-start p-1  bg-transparent" >{str}</th>
                            <td class="text-center p-0 bg-transparent">{planetData[(rowindex*3+col+1)][1].split(',')[index]}</td>
                            <td class="text-center p-0 bg-transparent">{planetData[(rowindex*3+col+1)][2].split(',')[index]}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                    </table>
                </div>
                ))}
              </div>    
            ))}


            </>
          )}
            </>
          }




        </>
        )
      }
                  </Col>
              </Row>
          </Collapse>
      }

      </>
   );
}